import {
  AutoOrderQuantityWriteResultEnum,
  AutoOrderQuantityWriteSourceEnum,
} from './auto-order-quantity-write.enum';

/**
 * ### IAutoOrderQuantityWriteLog
 * Safe diagnostic payload for a `setAOQuantities` write.
 * Must not include item descriptions, prices, comments, or credentials.
 *
 * @interface IAutoOrderQuantityWriteLog
 */
export interface IAutoOrderQuantityWriteLog {
  actionSource: AutoOrderQuantityWriteSourceEnum;
  environment: string;
  frontendVersion: string;
  orderId: string;
  preparedItemsCount: number;
  status: string;
  storeId: string;
  supplierId: string;
  supplierName: string;
  total: number;
  writeResult: AutoOrderQuantityWriteResultEnum;
  errorMessage?: string;
}

/**
 * ### IAutoOrderQuantityWriteLogInput
 * Inputs used to build {@link IAutoOrderQuantityWriteLog}.
 *
 * @interface IAutoOrderQuantityWriteLogInput
 */
export interface IAutoOrderQuantityWriteLogInput {
  actionSource: AutoOrderQuantityWriteSourceEnum;
  environment: string;
  frontendVersion: string;
  orderId: string;
  preparedItemsCount: number;
  status: string;
  storeId: string;
  supplierId: string;
  total: number;
  writeResult: AutoOrderQuantityWriteResultEnum;
  errorMessage?: string;
  supplierName?: string;
}
